import { Component, OnInit, AfterViewInit } from '@angular/core';
import { User } from '../../../admin/manage-users/shared/user.model';
import { AuthService } from '../../../../../core/services/auth.service';
import { UserService } from '../../../admin/manage-users/shared/user.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Credentials } from '../../../../../shared/objects/auth/credentials';
import { LoginStatusEnum } from '../../../../../shared/objects/enum/loginStatus';

@Component({
    selector: 'app-reset-password-form',
    templateUrl: './reset-password-form.component.html',
    styleUrls: ['./reset-password-form.component.scss'],
    standalone: false
})
export class ResetPasswordFormComponent implements OnInit, AfterViewInit {
  newPassword: string;
  confirmedPassword: string;
  submitted = false;

  currentUserInfo: User;

  private successMessage: string;
  private errorMessage: string;
  private resetGuid: string;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private routerService: Router,
    private translateService: TranslateService,
  ) {
    this.resetGuid = this.activatedRoute.snapshot.params['guid'];
  }

  // TODO: Refactor by adding a npm packages for the password validator
  get passwordConfirmed(): boolean {
    return this.newPassword === this.confirmedPassword;
  }
  get isImpersonated() {
    return this.authService.isImpersonated();
  }
  get allDataAvailable(): boolean {
    return !!this.newPassword && !!this.confirmedPassword;
  }

  get oldPasswordEqualNewPassword(): boolean {
    return (
      !!this.currentUserInfo &&
      this.newPassword === this.currentUserInfo.password
    );
  }

  ngOnInit() {
    this.setupTranslations();
  }

  ngAfterViewInit() {
    this.userService
      .getUserByResetPasswordGuid(this.resetGuid)
      .toPromise()
      .then(
        userInfo => {
          this.currentUserInfo = userInfo;
        },
        error => {},
      );
  }

  confirm() {
    this.submitted = true;
    if (!this.validate()) {
      return;
    }
    this.userService
      .updatePasswordAnonymous(this.resetGuid, this.newPassword)
      .toPromise()
      .then(res => {
        this.toastrService.success(this.successMessage);
      })
      .then(() => {
        this.login(this.currentUserInfo.username, this.newPassword);
      })
      .catch(() => {
        this.toastrService.error(this.errorMessage);
        this.resetForm();
      });
  }

  resetForm() {
    this.newPassword = '';
    this.confirmedPassword = '';
  }

  validate(): boolean {
    if (!this.passwordConfirmed) {
      return false;
    }
    if (this.oldPasswordEqualNewPassword) {
      return false;
    }
    return true;
  }

  private setupTranslations(): void {
    this.translateService
      .get('PASSWORD-CHANGE.PASSWORD-CHANGE-SUCCESS')
      .subscribe(t => (this.successMessage = t));
    this.translateService
      .get('PASSWORD-CHANGE.PASSWORD-CHANGE-ERROR')
      .subscribe(t => (this.errorMessage = t));
  }

  private login(username: string, password: string) {
    const credentials: Credentials = new Credentials();
    credentials.username = username;
    credentials.password = password;

    this.authService.login(credentials).then(res => {
      if (res.status === LoginStatusEnum.SUCCESS) {
        this.routerService.navigate([`/secure/dashboard`]);
      } else {
        this.routerService.navigate([`/login`]);
      }
    });
  }
}
